import React from "react";

function PageContent({ children }) {
  return (
      <div>{children}</div>
  );
}

export default PageContent;